export const setLocal = (name, data) => {
    return localStorage.setItem(name, data);
};
export const getLocal = (name) => {
    return localStorage.getItem(name);
};